<template>
  <Bar :options="chartOptions" :data="chartData" />
</template>

<script>
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'vue-chartjs';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
ChartJS.defaults.font.family = "'Space Grotesk', 'Courier New', Courier, monospace, sans-serif";

export default {
  name: 'BarChart',
  components: { Bar },
  props: {
    chartData: {
      type: Object,
      required: true
    },
    chartOptions: {
      type: Object,
      default: () => ({
        responsive: true,
        plugins: { legend: { display: false } }
      })
    }
  }
}
</script>
